import { styled } from 'styled-components'

export const Container = styled.div`
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 24px 20px;
  text-align: center;
`

export const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 20px;
  font-weight: 600;
  line-height: 140%;
`
